module.exports = __webpack_public_path__ + "static/media/HL4.8a3c9d8a.jpg";